require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-townhouse-manuals.json") })
        }
      }, "path---news-townhouse-manuals");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-townhouse-manuals!./.cache/json/news-townhouse-manuals.json
// module id = 859
// module chunks = 231608221292675